module.exports = __webpack_public_path__ + "static/media/13.fc0e586f.jpg";